module.exports = __webpack_public_path__ + "static/img/5616_phase_function_Paper_PointsHejduk_Prediction.9b9e7e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5616_phase_function_Paper_PointsHejduk_Prediction.png
// module id = XJSC
// module chunks = 0